export const XXXS_PHONE = 320
export const XXS_PHONE = 360
export const XS_PHONE = 375
export const S_PHONE = 414
export const IPHONEX_WIDTH = 1125



// WEBPACK FOOTER //
// ./src/constants/mediaQuery.js